var hasPerksGOLocations = function (deal) {
    return (!!(deal === null || deal === void 0 ? void 0 : deal.isInStoreDeal));
};
export default hasPerksGOLocations;
